import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CookieHandler } from 'src/shared/classes/cookie.class';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {

    const token = CookieHandler.getToken(); 

    if (token) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
